<template>
	<div>
		<el-drawer ref="messageDrawer"
			title="我的消息"
			:visible.sync="messageDrawerVisible"
			direction="rtl" size="40%">
			<div style="position:fixed;top:60px;right:25px;">
				<el-dropdown @command="handleStatusCommand">
					<span class="el-dropdown-link">
					{{query.statusName}}<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="" divided>全部状态</el-dropdown-item>
						<el-dropdown-item command="0" divided>未读</el-dropdown-item>
						<el-dropdown-item command="1" divided>已读</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				&nbsp;&nbsp;
				<el-dropdown @command="handleMessageTypeCommand">
					<span class="el-dropdown-link">
					{{query.selectName}}<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="" divided>全部消息</el-dropdown-item>
						<el-dropdown-item command="0" divided>系统消息</el-dropdown-item>
						<el-dropdown-item command="1" divided>公告消息</el-dropdown-item>
						<el-dropdown-item command="2" divided>业务消息</el-dropdown-item>
						<el-dropdown-item command="3" divided>其他消息</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<el-table :data="tableData" style="height:calc(100% - 117px); width:100%;margin-top:15px;
			font-size:14px;padding:2px;" 
			@selection-change="handleSelectionChange"
			stripe
			>
				<el-table-column type="selection" width="50" align="center" :selectable="isSelectable"></el-table-column>
				<el-table-column prop="messageType" label="消息类型" :formatter="messageTypeFormatter" width="80"></el-table-column>
				<el-table-column prop="title" label="标题"></el-table-column>
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						<el-tag :type="scope.row.status==0?'warning':'success'">
							{{statusFormatter(undefined, undefined, scope.row.status)}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="发布时间" width="160"></el-table-column>
				<el-table-column label="" width="80">
					<template slot-scope="scope">
						<el-button
							type="text"
							icon="el-icon-view"
							@click="handleShow(scope.$index, scope.row)"
						>详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="record-a-d">
				<el-button
					type="warning"
					icon="el-icon-reading"
					class="handle-del mr10"
					@click="handleRead"
				>标记已读</el-button>
			</div>
			<div class="pagination">
				<el-pagination
					background
					layout="total, prev, pager, next"
					:current-page="query.pageIndex"
					:page-size="query.pageSize"
					:total="pageTotal"
					@current-change="handlePageChange"
				></el-pagination>
			</div>
		</el-drawer>
		<el-drawer ref="messageDetailDrawer" title="详情"
			  :visible.sync="messageDetailDrawerVisible"
			  direction="rtl" size="30%">
			<el-form ref="show" :model="show" label-width="100px" style="height:calc(100% - 100px);margin:5px;">
				<el-descriptions class="margin-top" title="" :column="1" size="medium" border>
					<el-descriptions-item>
						<template slot="label">
							消息类型
						</template>
						{{messageTypeFormatter(null, null, show.messageType)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							发布时间
						</template>
						{{show.createTime}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							标题
						</template>
						{{show.title}}
					</el-descriptions-item>
				</el-descriptions>
				<div style="height:calc(100% - 170px);margin-top:20px;padding:10px;border:solid 1px #E4E7ED;">
					{{show.content}}
				</div>
			</el-form>
			<div class="pagination" style="margin:20px;">
				<el-button
					type="primary"
					@click="handleNext()"
				>下一条<i class="el-icon-arrow-right"></i></el-button>
			</div>
		</el-drawer>
	</div>
</template>

<style>
  .record-a-d {
	float:left; 
	padding-top:20px;
	padding-left:10px;
  }
</style>

<script>
import { fetchMyMessageData, deleteMessage, saveMessage, getMessage, readMessage, getDepartmentUserTree } from '../../api/index';
import bus from './bus';
export default {
    name: 'ChessDemand',
    data() {
        return {
			query:{
				statusName:"全部状态",
				status:"",
				selectName:"全部消息",
				messageType:"",
				pageIndex:1,
				pageSize:12
			},
			messageDrawerVisible:false,
			messageTypeMapping:{"":"全部消息","0":"系统消息","1":"业务消息","2":"公告消息","3":"其他消息"},
			statusMapping:{"":"全部状态","0":"未读","1":"已读"},
			messageDetailDrawerVisible:false,
			tableData:[],
			show:{},
			multipleSelection:[],
			currentIndex:0,
			pageTotal:0,
			unReadMessageMap:[]
        };
    },
	created() {
        bus.$on('message-drawer-open', msg => {
			if (msg) {
				this.unReadMessageMap = msg;
				this.$set(this.query, "status", "");
				this.$set(this.query, "statusName", "全部状态");
			} else {
				this.$set(this.query, "status", 0);
				this.$set(this.query, "statusName", this.statusMapping[0]);
			}
			this.getData();
			this.messageDrawerVisible = true;
        });
	},
    methods: {
		handleShow(index, row) {
			this.show = row;
			this.currentIndex = index;
			this.messageDetailDrawerVisible = true;
			readMessage([this.show.id]).then(res => {
				if (res.code == 0) {
					this.$set(this.show, "status", 1);
					bus.$emit("unReadMessageSizeUpdate", -1);
				}
			});
		},
		handleMessageTypeCommand(command) {
			this.query.selectName = this.messageTypeMapping[command];
			this.query.messageType = command;
			this.getData();
		},
		handleStatusCommand(command) {
			this.query.statusName = this.statusMapping[command];
			this.query.status = command;
			this.getData();
		},
		messageTypeFormatter(row, column, cellValue) {
			return this.messageTypeMapping[cellValue];
		},
		statusFormatter(row, column, cellValue) {
			return this.statusMapping[cellValue];
		},
		isSelectable(row, column, cellValue) {
			return row.status == 0;
		},
        getData() {
            fetchMyMessageData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取消息数据失败！" + res.message);
				}
            });
        },
		// 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		handleRead() {
			const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要标记为已读的记录！`);
				return;
			}
            let ids = [];
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要将选中的记录标记为已读吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					readMessage(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('标记成功');
							this.getData();
							bus.$emit("unReadMessageSizeUpdate", 0 - ids.length);
						} else {
							this.$message.error(`标记失败！` + res.message);
						}
					});
				})
				.catch(() => {});
		},
		handleNext() {
			this.currentIndex = this.currentIndex + 1;
			let index = this.currentIndex % 10;
			if (this.currentIndex > this.pageTotal - 1) {
				this.currentIndex = this.pageTotal - 1;
				this.$message.warning(`已经是最后一条了，没有记录了！`);
				return;
			}
			if (this.currentIndex > 0 && index == 0) {
				this.$set(this.query, 'pageNum', this.query.pageNum + 1);
				this.$set(this.query, 'pageIndex', this.query.pageNum + 1);
				this.getData();
			}
			this.show = this.tableData[index];
			if (this.show["status"] == 1) {
				return;
			}
			readMessage([this.show.id]).then(res => {
				if (res.code == 0) {
					this.$set(this.show, "status", 1);
					bus.$emit("unReadMessageSizeUpdate", -1);
				}
			});
		}
    }
};
</script>
